import React from 'react';

export default class HoverTableRow extends React.Component {
    setHover(event) {
        const row = event.target.closest("tr");
        if (!row) return; // event originated in a portal (e.g. hover card), not inside the row

        const showHover = typeof(event.target.className) === 'string' && event.target.className.indexOf("input") < 0;

        if (showHover && row.className.indexOf("hover") < 0) {
            row.classList.add(this.props.disabled ? "disabled-hover" : "hover");
        } else if (!showHover) {
            row.classList.remove("hover");
        }
    }

    removeHover(event) {
        const row = event.target.closest("tr");
        if (!row) return;

        row.classList.remove(this.props.disabled ? "disabled-hover" : "hover");
    }

    onClick(event) {
        if (this.props.onClick && event.target.className.indexOf("input") < 0) {
            this.props.onClick();
        }
    }
    
    onDoubleClick (event) {
        if (this.props.onDoubleClick  && event.target.className.indexOf("input") < 0) {
            this.props.onDoubleClick ();
        }
    }

    render() {
        return <tr className="table-row" {...this.props} onClick={this.onClick.bind(this)} onDoubleClick ={this.onDoubleClick.bind(this)}
            onMouseOver={this.setHover.bind(this)} onMouseLeave={this.removeHover.bind(this)}>{this.props.children}</tr>
    }
}



// WEBPACK FOOTER //
// ./src/components/commonComponents/util/HoverTableRow.jsx